import { formatCost, formatNumber } from '../../utils/formatUtils';

export function tenantDisplayName(tenant: {
  name: string;
  displayName?: string | null;
}): string {
  return tenant.displayName?.trim() || tenant.name;
}

export function isPositiveLimit(
  value: number | null | undefined,
): value is number {
  return value != null && Number.isFinite(value) && value > 0;
}

export function formatLimitUsage(
  estimatedCosts: number | null | undefined,
  costLimit: number,
  locale: string,
): string {
  return `${formatCost(estimatedCosts, locale)} / ${formatCost(costLimit, locale)}`;
}

export function formatCountWithMax(
  count: number,
  max: number | null | undefined,
  locale: string,
): string {
  const countLabel = formatNumber(count, locale);
  if (max == null || !Number.isFinite(max)) {
    return countLabel;
  }
  return `${countLabel} / ${formatNumber(max, locale)}`;
}

export function isLimitReached(
  count: number,
  max: number | null | undefined,
): boolean {
  return max != null && Number.isFinite(max) && count >= max;
}
